import { css, html, LitElement, unsafeCSS } from 'lit';
import selectedDataStyles from './selected-data.scss?inline';

export class SelectedData extends LitElement {
    static override styles = [
        css`
            ${unsafeCSS(selectedDataStyles)}
        `,
    ];

    override render() {
        return html`<div><slot></slot></div>`;
    }
}
